import { Tooltip } from "ant-design-vue";
import { type Directive, createApp, h } from "vue";

type TooltipPlacement =
  | "top"
  | "left"
  | "right"
  | "bottom"
  | "topLeft"
  | "topRight"
  | "bottomLeft"
  | "bottomRight"
  | "leftTop"
  | "leftBottom"
  | "rightTop"
  | "rightBottom";

/**
 * tooltip
 * @example  <div v-tooltip:topLeft="item.desc">{{ item.desc }}</div>
 */
export default {
  mounted(el, binding) {
    const _el = el as any;
    const parentElem = el.parentElement;
    const instance = createTooltip(binding.value, binding.arg as TooltipPlacement);
    parentElem?.insertBefore(instance.$el, el);
    instance.$el.appendChild(el);
    _el.tooltip = instance;
  },
  unmounted(el) {
    const _el = el as any;
    const tooltipInstance = _el.tooltip;
    if (tooltipInstance) {
      tooltipInstance.unmount();
      _el.tooltip = undefined;
    }
  },
  updated(el, binding) {
    const _el = el as any;
    const parentElem = el.parentElement;
    if (_el.tooltip) {
      _el.tooltip.unmount();
      _el.tooltip = undefined;
    }
    const instance = createTooltip(binding.value, binding.arg as TooltipPlacement);
    parentElem?.insertBefore(instance.$el, el);
    instance.$el.appendChild(el);
    _el.tooltip = instance;
  },
} as Directive;

function createTooltip(title: string, placement?: TooltipPlacement) {
  // 创建Tooltip组件实例
  const container = document.createElement("div");
  const app = createApp({
    render() {
      return h(Tooltip, {
        title,
        placement: placement || "top",
      });
    },
  });

  app.mount(container);

  return {
    $el: container.firstElementChild as HTMLElement,
    unmount: () => app.unmount(),
  };
}
